import get from 'lodash/get';

import { DEFAULT_LANGS } from 'server/constants';
import { Langs } from 'shared/types';

export default function getZoneLangs(state: any): Langs {
  return get(state, 'page.data.zone.langs', DEFAULT_LANGS);
}
